module.exports = __webpack_public_path__ + "static/media/see-available-incentives.a289ff2e.svg";